import Menu from "../../components/Menu/Menu"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { useTranslation } from "react-i18next"
import {
  faCheck,
  faClose,
  faDatabase,
  faLock,
  faMoneyBill,
  faPhone,
  faUpload,
  faUser,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { SEO } from "../../seo/Seo"
import { ContractDownloadsCard } from "../../components/ContractDownloads/ContractDownloadsCard"

export default function TermsOfService() {
  const { t } = useTranslation("term")

  const sections = [
    {
      icon: faCheck,
      title: t("term1_title"),
      content: [t("term1_description")],
    },
    {
      icon: faUser,
      title: t("term2_title"),
      content: [t("term3_description")],
    },
    {
      icon: faTriangleExclamation,
      title: t("term3_title"),
      content: [t("term3_description"), t("term3_description1")],
    },
    {
      icon: faDatabase,
      title: t("term4_title"),
      content: [t("term4_description"), t("term4_description")],
    },
    {
      icon: faUpload,
      title: t("term5_title"),
      content: [t("term5_description")],
    },
    {
      icon: faMoneyBill,
      title: t("term6_title"),
      content: [t("term6_description")],
    },
    {
      icon: faPhone,
      title: t("term7_title"),
      content: [t("term7_description")],
    },
    {
      icon: faLock,
      title: t("term8_title"),
      content: [t("term8_description"), t("term8_description1")],
    },
    {
      icon: faClose,
      title: t("term9_title"),
      content: [t("term9_description")],
    },
  ]

  return (
    <Animate type={AnimationTypes.fadeIn}>
      <div className="min-h-screen bg-white">
        <SEO
          title="Termos de serviço para software de loja catalojei"
          description="Leia os termos de serviço do catalojei, sistema de gestão para loja SaaS com pedidos online e catálogo digital."
          path="/terms-of-service"
        />

        <Menu />

        <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="space-y-8 mt-20">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-white border-l-4 border-red-500 shadow-md rounded-lg p-6 transition hover:shadow-lg"
              >
                <div className="flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left gap-4">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-orange-400 flex items-center justify-center text-white shadow-md">
                    <FontAwesomeIcon icon={section.icon} />
                  </div>

                  <div className="flex-1">
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-3">{section.title}</h2>

                    <div className="space-y-3">
                      {section.content.map((text, i) => (
                        <p key={i} className="text-sm sm:text-base text-gray-600 leading-relaxed">
                          {text}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}

            <ContractDownloadsCard showAutomaticAcceptance />
          </div>
        </main>
      </div>
    </Animate>
  )
}
